<div class="flex flex-column">
    <span class="text-lg font-semibold" style="color: #343535;">
        <app-translate key="PAYMENT_INFORMATION"></app-translate>
    </span>
    <p-divider></p-divider>
</div>
<div class="flex flex-column flex flex-column p-2">
    <h3 class="m-0">Wireless Upgrade Payment</h3>
    <span class="text-lg font-semibold" style="color: #343535;">
        <p class="subtitle">To continue with this order, please pay the balance below.</p>
    </span>
    
</div>
<p-divider></p-divider>
<div class="mt-2">
    @if (todaysChargesTotal()) {
    <!-- Payment Required Template -->
    <div class="flex flex-column">
        <div class="due-today flex justify-content-start bg-gray-300 align-items-center px-2 py-3 mb-3">
            <div class="text-base font-semibold"><app-translate key="DUE_TODAY"></app-translate>: </div>
            <div style="font-size: 20px;" class="font-semibold">{{todaysChargesTotal() |
                currency}}</div>
           
        </div>
        <div class="flex flex-column py-3">
             <a href="#" class="text-primary">Show Order Summary</a>
        </div>
        <div class="flex flex-column gap-3">
            <div>
                <span class="text-base font-semibold"><app-translate key="BILLING_INFORMATION"></app-translate></span>
            </div>
            <app-credit-card-billing #todayChargesCreditCardBilling
                [ServiceAvailabilityZipCode]="ServiceAvailabilityZipCode"
                [PaymentZipMustMatchService]="PaymentZipMustMatchService"></app-credit-card-billing>
            <div class="flex flex-column">
                <span class="text-base font-semibold"><app-translate key="PAYMENT_AUTHORIZATION"></app-translate></span>
                <p-button [label]="languageService.getTranslation('READ_TERMS_CONDITIONS')" [link]="true"
                    styleClass="outline-none pl-0" (onClick)="paymentAuthorizationDialog = true"></p-button>
            </div>
            <div>
                <div class="mb-1 flex flex-row">
                    <div class="flex align-items-center">
                        <div
                            [ngStyle]="{'border': showErrors && !termsAccepted ? '1px solid red' : 'none', 'display': 'inline-block', 'padding': '2px'}">
                            <p-checkbox [(ngModel)]="termsAccepted" [binary]="true" inputId="binary" />
                        </div>
                        <label for="binary" class="font-light pl-2 pt-1 text-base">
                            <app-translate key="AGREE_PAYMENT_TERMS"></app-translate>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <p-divider class="mb-5"></p-divider>
    </div>
    }

</div>


<div class="flex flex-column mt-5">
    <div class="mb-3">
        <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onSubmitClicked()"
            styleClass="p-button-lg w-full p-button-primary" />
    </div>
    <div class="mb-3">
        <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
            (onClick)="onCancelClick()" />
    </div>
</div>

<div class="flex flex-column mt-5">
    <span class="text-sm font-light">
        <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
    </span>
</div>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
    [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
    (Result)="onCancel($event)"></app-confirm-popup>

<p-dialog [header]="paymentErrorDialogTitle" [modal]="true" [(visible)]="paymentErrorDialogVisible"
    [breakpoints]="{ '5550px': '50vw','575px': '90vw' }" styleClass="border-round-3xl">
    <div class="flex flex-column gap-3">
        <div [innerHTML]="paymentErrorDialogMessage"></div>
        <div class="flex flex-1 gap-3 justify-content-end">
            <p-button [label]="languageService.getTranslation('OKAY')" styleClass="p-button-raised"
                (click)="this.paymentErrorDialogVisible = false" rounded="true"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog [(visible)]="paymentAuthorizationDialog"
    [header]="languageService.getTranslation('PAYMENT_AUTHORIZATION_TERMS')"
    [breakpoints]="{ '5550px': '50vw','575px': '90vw' }" styleClass="border-round-3xl" appendTo="body" [modal]="true"
    [blockScroll]="true" [closeOnEscape]="false">
    <div class="terms-content max-h-70vh overflow-y-auto">
        <div>
            <h4><app-translate key="PARTIES"></app-translate></h4>
            <p><app-translate key="PARTIES_DESCRIPTION"></app-translate></p>

            <h4><app-translate key="ONE_TIME_PAYMENT_AUTH"></app-translate></h4>
            <p><app-translate key="ONE_TIME_PAYMENT_AUTH_DESCRIPTION"></app-translate></p>

            <h4><app-translate key="PAYMENT_METHOD"></app-translate></h4>
            <p><app-translate key="PAYMENT_METHOD_DESCRIPTION"></app-translate></p>

            <h4><app-translate key="REVOCATION"></app-translate></h4>
            <p><app-translate key="REVOCATION_DESCRIPTION"></app-translate></p>

            <h4><app-translate key="GENERAL"></app-translate></h4>
            <p><app-translate key="GENERAL_DESCRIPTION"></app-translate></p>
        </div>
    </div>
    <div class="flex flex-1 gap-3 justify-content-end">
        <p-button [label]="languageService.getTranslation('CLOSE')" [link]="true" styleClass="button"
            (click)="paymentAuthorizationDialog = false" />
    </div>
</p-dialog>